module.exports = __webpack_public_path__ + "static/media/feature-clinic-management.9d83fa24.png";